import { defineNuxtRouteMiddleware } from "nuxt/app";
import { useUserStore } from "~/store/user/userStore";

export default defineNuxtRouteMiddleware(async (to) => {
    // URL 접두어에서 언어코드 추출: /en/..., /ja/..., /ko/...
    const m = to.path.match(/^\/(en|ja|ko|es|vi)(?:\/|$)/)
    if (!m) return

    // SEC-1 (TSK-10568): JS can't read the HttpOnly AccessToken cookie. Use store state
    // (populated by getUserData in app.vue) as the logged-in signal. On cold loads the
    // store may not yet be hydrated, in which case the user keeps their /en/ prefix —
    // a graceful degradation; subsequent in-app navigation goes through the redirect.
    const userToken = useUserStore().userV2?.uuid ?? '';

    if (userToken) {
        // 사용자 토큰이 있는 경우: 언어 접두어 제거하고 기본 경로로 리다이렉트
        const pathWithoutLang = to.path.replace(/^\/(en|ja|ko|es|vi)/, '')

        // 리다이렉트 실행
        return navigateTo(pathWithoutLang, { redirectCode: 301 })
    }

    // 사용자 토큰이 없는 경우: SEO를 위한 언어 설정만 적용
    const nuxtApp = useNuxtApp()
    const target = m[1] as "en" | "es" | "vi" | "ko" | "ja"

    // await $i18n.setLocale()은 i18n의 자체 "locale-changing" 미들웨어와 경합해 SSG
    // 빌드에서 앱 마운트가 멈추는 문제가 있었다(TSK-11540). 메시지는 eager 로드라
    // 비동기가 필요 없으므로 locale ref만 직접 갱신해 우회한다. SEO 전용 오버라이드라
    // LANG 쿠키는 건드리지 않는다.
    if (nuxtApp.$i18n?.locale?.value !== target) {
        nuxtApp.$i18n.locale.value = target
    }
})